import { render, staticRenderFns } from "./ProtocolosLista.vue?vue&type=template&id=25a2d198&scoped=true&"
import script from "./ProtocolosLista.vue?vue&type=script&lang=js&"
export * from "./ProtocolosLista.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolosLista.vue?vue&type=style&index=0&id=25a2d198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2d198",
  null
  
)

export default component.exports